import { getFileSrc } from '@/utils/utilities';
import { Loader } from './Loader';
import * as THREE from 'three';

export class AssetsLib {
	private loader = Loader.getInstance();
	texturesCache = new Map<string, THREE.Texture>();
	materialCache = new Map<string, THREE.MeshStandardMaterial>();
	models = new Map<string, THREE.Group<THREE.Object3DEventMap>>();

	private static instance: AssetsLib;

	private constructor() {}

	static getInstance() {
		if (!AssetsLib.instance) AssetsLib.instance = new AssetsLib();
		return AssetsLib.instance;
	}

	async loadModel(path: string) {
		const fileType = path.split('.').pop();

		switch (fileType) {
			case 'glb':
			case 'gltf':
				const gltf = await this.loader.gltfLoader.loadAsync(getFileSrc(path));
				this.models.set(path, gltf.scene);
				return gltf.scene.clone();
			case 'fbx':
				const group = await this.loader.FBXLoader.loadAsync(getFileSrc(path));
				this.models.set(path, group);
				return group.clone();

			default:
				throw new Error('UNSUPPORTED_MODEL_TYPE');
		}
	}
}
